import "./PriceCard.css";
import { Dispatch, FC, SetStateAction } from "react";
import { RentalPrice } from "../../api/types";
import { FormatMoney } from "./../../utils/format";
import Button from "../ui/Button";

interface Props {
  offer: RentalPrice;
  setSelected: Dispatch<SetStateAction<RentalPrice | undefined>>;
}
const PriceCard: FC<Props> = ({ offer, setSelected }) => {
  const transmission = offer.isAutomatic ? "Automático" : "Manual";
  const imageSrc =
    offer.category.cars?.[0]?.pictures?.[0] ??
    process.env.REACT_APP_IMG_PATH + "/img/car-no-image.webp";

  return (
    <>
      <div
        className="tw-price-card-wrapper tw-shadow-md hover:tw-shadow-xl active:tw-shadow tw-ease-in tw-duration-300 tw-align-middle tw-items-center tw-grid"
        onClick={() => setSelected(offer)}
      >
        <div className="tw-grid tw-grid-cols-12 tw-space-x-3 tw-items-center">
          <div className="tw-col-span-4 sm:tw-col-span-3">
            <img
              src={imageSrc}
              alt={`${offer.category.nameSpanish} ${transmission}`}
              width={99}
              height={57}
            />
          </div>
          <div className="tw-col-span-4 sm:tw-col-span-5">
            <div className="tw-car-category">{offer.category.nameSpanish}</div>
            <div className="tw-car-description">{transmission}</div>
          </div>
          <div className="tw-col-span-4 sm:tw-col-span-4 tw-bg-gray-100 tw-rounded-md tw-h-full tw-text-center tw-p-2">
            <div className="tw-items-baseline tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-indigo-600 tw-mb-1 tw-text-center">
              {FormatMoney(offer.cost.dailyPrice, true)}
              <span className="tw-ml-1 tw-text-sm tw-font-medium tw-text-gray-500">
                /día
              </span>
            </div>
            <Button label="Rentar" size="xs" />
          </div>
        </div>
      </div>
    </>
  );
};

export default PriceCard;
